import { render, staticRenderFns } from "./info-tab.vue?vue&type=template&id=0e309212&"
import script from "./info-tab.vue?vue&type=script&lang=js&"
export * from "./info-tab.vue?vue&type=script&lang=js&"
import style0 from "./info-tab.vue?vue&type=style&index=0&id=0e309212&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports